import React, { useEffect } from 'react'
import Options from './stages/Options'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useRaportForm } from '../../context/RaportFormContext'

const ShortRaportForm = ({
  cardInsertionPeriods = false,
  cardMarkers = false,
  vehicleActivity = false,
  separateFilesOnly = false,
}: {
  cardInsertionPeriods?: boolean
  cardMarkers?: boolean
  vehicleActivity?: boolean
  separateFilesOnly?: boolean
}) => {
  const { data, setData } = useRaportForm()
  const { t } = useLocalize()
  useEffect(() => {
    setData({
      // onlyForActiveVehicles: false,
      separateFiles: false,
      issuerSignature: false,
      driverSignature: false,
    })
  }, [])
  return (
    <div className="tw-flex-1 tw-overflow-auto tw-p-4 tw-pr-8">
      {cardMarkers && <CheckboxWithLabelField label={t('printout.cardMarkersBasic')} value={data?.basicVersion === true} onChange={() => setData({ ...data, basicVersion: !data?.basicVersion })} />}
      {cardInsertionPeriods && <>
        <CheckboxWithLabelField label={t('printout.fillCardGaps')} value={data?.fillGapsInCsv !== false} onChange={() => setData({ ...data, fillGapsInCsv: data?.fillGapsInCsv === false })} />
        <CheckboxWithLabelField label={t('printout.groupCardPeriods')} value={data?.groupByDrivers === true} onChange={() => setData({ ...data, groupByDrivers: !data?.groupByDrivers })} />
      </>}
      <Options
        setData={setData}
        data={data}
        vehicleActivity={vehicleActivity}
        separateFilesOnly={separateFilesOnly}
      />
    </div>
  )
}

export default ShortRaportForm
